<template>
  <b-modal
    id="mc-modal-reject"
    centered
    scrollable
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="md"
    :title="$t('deliveryRequest.modal.rejectFleetTask.title')"
  >
    <div class="mc-modal-reject card-body">
      <p class="mc-modal-reject__text">
        <span v-if="!isFromList">
          <span v-html="$t('deliveryRequest.modal.rejectFleetTask.single', { companyName })"></span>
        </span>
        <span v-else>
          {{ $t('deliveryRequest.modal.rejectFleetTask.multiple', { total }) }}
          <p class="mt-2">
            {{ $t('deliveryRequest.modal.rejectFleetTask.warning') }}
          </p>
        </span>
      </p>

      <FormulateForm v-model="formValues" name="reason-form" @submit="handleSubmit">
        <FormulateInput
          v-model="rejectedReason"
          type="text"
          name="rejected_reason"
          :label="$t('deliveryRequest.modal.rejectFleetTask.reasonLabel')"
          :placeholder="$t('deliveryRequest.modal.rejectFleetTask.reasonPlaceholder')"
          validation="required"
          error-behavior="submit"
          :validation-messages="{
            required: $t('deliveryRequest.modal.rejectFleetTask.reasonRequired'),
          }"
        />
      </FormulateForm>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton :disabled="isLoading" variant="secondary" :text="$t('global.no')" @click="cancel" />
        <McButton :disabled="isLoading" :text="$t('deliveryRequest.modal.rejectFleetTask.confirm')" @click="triggerSubmit" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    showResponse: {
      type: Object,
      default: () => {},
    },
    isFromList: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  emits: ['transition'],
  data() {
    return {
      isLoading: false,
      rejectedReason: '',
      formValues: {},
    }
  },
  computed: {
    companyName() {
      return this.showResponse?.parent_company?.name
    },
  },
  methods: {
    triggerSubmit() {
      this.$formulate.submit('reason-form')
    },
    handleSubmit() {
      this.isLoading = true

      const data = {
        status: 'REJECTED',
        fields: {
          rejected_reason: this.rejectedReason,
        },
      }

      this.$emit('transition', 'REJECT', data)
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-modal-reject {
  &__text {
    span {
      white-space: nowrap;
      display: inline-block;
    }
    strong {
      font-weight: 600;
    }
    p {
      margin-bottom: 0;
    }
  }
}
</style>
